import React from 'react';
import PropTypes from 'prop-types';
import KeszletcsokkenesForm from './KeszletcsokkenesForm';
import { useNavigate } from 'react-router';

const cardStyle = {
  padding: 20
};

export default function WithNav(props) {
  return <KeszletcsokkenesBase {...props} navigate={useNavigate()} />
}

const KeszletcsokkenesBase = (props) => {
  return (
    <div className="animated fadeIn">
      <div className="card">
        <div className="card-header">
          {props.modositas == 'true' ? 'Készletcsökkenés módosítása' : 'Új készletcsökkenés'}
        </div>
        <div className="row" style={cardStyle}>
          <div className="col-md-12">
            <KeszletcsokkenesForm {...props} globals={props.globals} />
          </div>
        </div>
      </div>
    </div>
  );
};

KeszletcsokkenesBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};
